<template>  
  <div>
  </div>
</template>
<script>
export default{
	data(){
		return {
			
		}
	},
	components:{
	},
	methods:{		
	},
	created(){
		this.$store.commit('SET_LOGOUT');
		this.$router.push({path: './'});
	}
}
</script>